import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './index'; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function (initialState) {
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunk)));
}